export default __webpack_public_path__ + "static/media/Tier2.c3a9a517.svg";